import { useEffect } from 'react';
import LockIcon from '../icons/LockIcon';
import { useTranslation } from 'react-i18next';
const CensuredScreen = ({ title, text1, text2, showLogout = false, onLogout }) => {
  const { t } = useTranslation();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    return () => {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
    };
  }, []);
  return (
    <div className='censured-text fade-up'>
      <LockIcon size='50px' color='#fff' />

      <div className='text-center mt-4'>
        <div className='fw-600 font-medium'>{title}</div>
        {text1 && <div className='mt-3'>{text1}</div>}
        {text2 && <div className='mt-3'>{text2}</div>}
      </div>

      {showLogout && (
        <div className='text-center mt-4'>
          <div className='text-center mt-3 text-secondary' onClick={onLogout}>
            {t('menu.logout')}
          </div>
        </div>
      )}
    </div>
  );
};

export default CensuredScreen;